import React from 'react'
import { BsLinkedin } from 'react-icons/bs'
import { FaGithub } from 'react-icons/fa'
import { FiInstagram } from 'react-icons/fi'
import { IconContext } from "react-icons";

const HeaderSocials = () => {
  return (
    <div className="header__socials">

      <IconContext.Provider value={{ className: "shared-class", size: 30 }}>
        <a href="https://www.linkedin.com/in/tejas-patne-80a018239/" target="_blank" title='linkedin profile'><BsLinkedin /></a>
        <a href="https://github.com/TejasPatne" target="_blank" title='github profile'><FaGithub /></a>
        <a href="https://instagram.com/tejas_patne_45" target="_blank" title='instagram profile'><FiInstagram /></a>
      </IconContext.Provider>
    </div>
  )
}

export default HeaderSocials